<template>
  <div class="search-wrap" v-if="showHeaderSearch">
    <div class="search">
      <div class="icon-box" @click="search()">
        <i class="el-icon-search"></i>
      </div>
      <el-input
        popper-class="autocomplete"
        v-model="state"
        @keyup.enter.native="search()"
        placeholder="全球设计灵感搜索，限时内测"
      >
      </el-input>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showHeaderSearch: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      state: "",
      restaurants: [],
    };
  },
  mounted() {
    //this.restaurants = this.loadAll();
  },
  methods: {
    selectSearchInfo(val) {
      this.$emit("selectSearch", val);
    },
    search() {
      //this.$emit('clickSearch', this.state);
      if (this.state !== "") {
        if (this.$route.path == "/materialCenter") {
          this.$EventBus.$emit("gotoSearch", this.state);
        } else {
          this.$router.push({
            path: "/materialCenter",
            query: { listKey: this.state },
          });
        }
        this.$store.commit("headerMenuId", "materialCenter");
			  this.$store.commit("asideMenuId", "materialCenter");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.search-wrap {
  min-width: 260px;
  flex-shrink: 2;
  margin-right: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 2;
  .search {
    position: relative;
    width: 100%;
    height: 100%;
  }
}

::v-deep .el-icon-search:hover {
  color: #0773fc !important;
  font-weight: 700;
}
</style>
